module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b",
    attrs: {
      "id": "frontmatter01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Text/Contents#rfrontmatter01"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("This book is the culmination of many years of trials, tribulations, research, missteps, exploration and experimentation. The ideas presented are an amalgamation of decades-old knowledge, cutting-edge research, professional industry expertise and our own conclusions based on our results. Throughout you will find overlap with other programs, inspiration from other nutrition regimes, and homage to some of the old-school truths of bodybuilding. We hope you enjoy the ride!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("We want to give credit where credit is due. Our workout draws inspiration from many other programs, including Jim Wendler’s 5/3/1 ("), _c('a', {
    attrs: {
      "href": "http://www.jimwendler.com",
      "target": "_blank"
    }
  }, [_vm._v("www.jimwendler.com")]), _vm._v("), Dante Trudel’s Doggcrapp Training (seriously, that’s the name—"), _c('a', {
    attrs: {
      "href": "http://dc-training.blogspot.com",
      "target": "_blank"
    }
  }, [_vm._v("dc-training.blogspot.com")]), _vm._v(") and the venerable old-school favorite, German Volume Training (GVT).")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Our nutrition regime could not have been created without research and exploration done by Martin Berkhan ("), _c('a', {
    attrs: {
      "href": "http://www.leangains.com",
      "target": "_blank"
    }
  }, [_vm._v("www.leangains.com")]), _vm._v("), Jason Ferruggia ("), _c('a', {
    attrs: {
      "href": "http://jasonferruggia.com",
      "target": "_blank"
    }
  }, [_vm._v("jasonferruggia.com")]), _vm._v(") and John Kiefer ("), _c('a', {
    attrs: {
      "href": "http://www.dangerouslyhardcore.com",
      "target": "_blank"
    }
  }, [_vm._v("www.dangerouslyhardcore.com")]), _vm._v("). A hearty thank you to all of the above for giving to the greater good, which allowed us to create our own humble contribution.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-385f24de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Frontmatter01.vue
// module id = 69
// module chunks = 0